import React from "react";
import _ from "lodash";
import { useTranslation } from "react-i18next";

import TeamLogo from "../../_partials/TeamLogo";
import { PresetColors } from "../../../../shared/components/MediaLibrary/EditModal/LeftSidebar/EditTab";
import watchTime from "./images/watch_time.webp";

// Everything this template paints on top of its background layers.
//
// The editor canvas draws those layers itself as draggable boxes, so it renders
// this overlay alone (see EditModal/slider4Content.js) while the template's
// Index.jsx renders it over its own static copy of them. Both get the same
// markup from here, which is what stops the preview and the exported image
// drifting apart.
const SliderOverlay = ({ data, jersey, hasCLStars, isDfbPokal }) => {
  const { t } = useTranslation();

  const { timezones, matchInfo } = data?.data?.dynamic || {};
  const selectedLang = data?.lang;
  const competitionId = data?.event?.competitionId;
  const homeTeam = matchInfo?.contestant?.[0];
  const awayTeam = matchInfo?.contestant?.[1];

  const date = data?.event?.date;
  const time = data?.event?.time;
  const [day, month, year] = date.split(".");
  const basetime = new Date(`${year}-${month}-${day}T${time}`);

  // The variant the kick-off times key off. It is not the kit alone: a cup or
  // European tie is its own look, so the precedence is the same chain slider 2
  // uses -- Pokal, then CL, then the kit -- and style.scss carries a treatment
  // for each. In practice only `black` differs here (the time turns red);
  // `ucl` and `dfb` fall through to the all-white default, which is the point
  // of naming them rather than letting a black-kit fixture tint the time on
  // competition artwork.
  const variantClass = isDfbPokal
    ? "dfb"
    : hasCLStars
      ? "ucl"
      : jersey === PresetColors.white
        ? "white"
        : jersey === PresetColors.red
          ? "red"
          : "black";

  return (
    <>
      {/* The competition artwork, on the same switches as the rest of each
          look. `variantClass` has already resolved the precedence between them,
          so these two are mutually exclusive by construction rather than by
          checking the flags again. It lives here rather than beside the
          background layers so the editor preview picks it up from the same
          component the export renders. */}
      {variantClass === "ucl" && <div className="ucl-gradient"></div>}
      {variantClass === "dfb" && <div className="dfb-gradient"></div>}
      <div className="first-bottom-container">
        <div className={`${selectedLang === 'ar' ? 'logo-container-ar' : 'logo-container'}`}>
          {/* <div className={`label-match-info-glow ${jersey === PresetColors.white ? 'white' : jersey === PresetColors.red ? 'red' : 'black'}`}>
          {t("Watch Time", { keyPrefix: "table", lng: selectedLang })}
        </div>
        <div className={`label-match-info ${jersey === PresetColors.white ? 'white' : jersey === PresetColors.red ? 'red' : 'black'}`}>
          {t("Watch Time", { keyPrefix: "table", lng: selectedLang })}
        </div> */}
        </div>
        <div className={`${selectedLang === 'en' ? 'team-logo-container' : selectedLang === 'ar' ? 'team-logo-container-ar' : 'team-logo-container-non'}`}>
          {/* <div className="home-team-logo-container">
          <TeamLogo team={homeTeam} competitionId={competitionId} />
        </div> */}
          {/* <div className="away-team-logo-container">
          <TeamLogo team={awayTeam} competitionId={competitionId} />
        </div> */}
        </div>
        <div class="time-container">
          <div class="time-series">
            <div class="right">
              <div className="watch-time">
                <img
                  src={watchTime}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
              </div>
              {timezones?.map(({ city, timezone }, index) => {
                const localTime = basetime?.toLocaleString("en-US", {
                  timeZone: timezone,
                  hour: "numeric",
                  minute: "numeric",
                  hour12: true,
                });
                if (city === 'Munich') {
                  return <div className="base-time">
                    <span class={`time ${variantClass}`}>{localTime}</span>
                    <span class={`city ${variantClass}`}>{t(city, { keyPrefix: "table", lng: selectedLang })}</span>
                  </div>
                }
                return (
                  <div class="time-row">
                    <span class={`time ${variantClass}`}>{localTime}</span>
                    <span class={`city ${variantClass}`}>{t(city, { keyPrefix: "table", lng: selectedLang })}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      {/* <div className={`gradient-image-${jersey === PresetColors.white ? 'white' : jersey === PresetColors.red ? 'red' : 'black'}`}></div> */}
    </>
  );
};

export default SliderOverlay;
